// Only one item MUST have the "default: true" key

module.exports = {
    cs: {
        default: true,
        path: `cs`,
        locale: `cs-BR`,
        dateFormat: `DD/MM/YYYY`,
        siteLanguage: `cs`,
        ogLanguage: `CZ`,
        defaultTitle: `EKP - profesionální daňoví a účetní poradci`,
        defaultDescription: `Soustřeďte se na své podnikání a přenechte nám starosti s: ✓přímými a nepřímými daněmi, ✓mzdovou a účetní agendou, ✓přesuny majetku aj. Zjistěte více.`,
    },
    en: {
        path: `en`,
        locale: `en-US`,
        dateFormat: `DD/MM/YYYY`,
        siteLanguage: `en`,
        ogLanguage: `EN`,
        defaultTitle: `EKP - taxes and consulting`,
        defaultDescription: `Soustřeďte se na své podnikání a přenechte nám starosti s: ✓přímými a nepřímými daněmi, ✓mzdovou a účetní agendou, ✓přesuny majetku aj. Zjistěte více.`,
    },
}
